import Skeleton from "@mui/material/Skeleton";
import { useTranslation } from "~contexts/I18nContext/I18nContext";
import { useOfflineContext } from "~contexts/OfflineContext/useOfflineContext";
import type { TimeWorked } from "~generated";
import { classList } from "~lib/classList";
import { secsToHoursAndMins } from "~lib/timeHelpers";
import { OfflineNotice } from "./OfflineNotice";
import { TimeCard } from "./TimeCard";
import styles from "./TimeWorkedCards.module.scss";

type TimeWorkedCardsProps = {
  timeWorked: TimeWorked;
};

export function TimeWorkedCards({ timeWorked }: TimeWorkedCardsProps) {
  const t = useTranslation();
  const { isOffline } = useOfflineContext();

  return (
    <output aria-label={t.timeWorked}>
      <div
        className={classList(styles.container, isOffline && styles.disabled)}
      >
        <TimeWorkedCard time={timeWorked.today} label={t.today} />
        <TimeWorkedCard time={timeWorked.this_week} label={t.thisWeek} />
        <TimeWorkedCard time={timeWorked.this_month} label={t.thisMonth} />
      </div>
      {isOffline && <OfflineNotice />}
    </output>
  );
}

export function TimeWorkedCardsSkeleton() {
  return (
    <div className={styles.container}>
      <Skeleton height={78} />
      <Skeleton height={78} />
      <Skeleton height={78} />
    </div>
  );
}

type TimeWorkedCardProps = {
  time: number;
  label: string;
};

function TimeWorkedCard({ time, label }: TimeWorkedCardProps) {
  const { hours, minutes } = secsToHoursAndMins(time);
  return <TimeCard label={label} hours={hours} minutes={minutes} />;
}
